import React, { Component } from 'react';
import { translate } from 'react-i18next';

import { Table, Button } from 'react-bootstrap';
import Moment from 'moment';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';
import TooltipButton from './TooltipButton';
import TooltipLink from './TooltipLink';

class QAndATable extends Component {
    didConfirmDelete(question) {
        this.props.onDelete(question);
    }

    handleDeleteClicked(question) {
        const { t } = this.props;

        this.dialog.show({
            title: t('Dialog.warning'),
            body: t('Dialog.sure_deletion'),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.didConfirmDelete(question),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    render() {
        const { t } = this.props;

        let questionRows = this.props.questions.map((question, index) => {
            return (
                <tr key={index}>
                    <td>{question.id}</td>
                    <td>{question.type}</td>
                    <td>{question.description}</td>
                    <td>{question.answer}</td>
                    <td align="center">
                        <TooltipLink
                            id="editButton"
                            className="btn btn-default"
                            tooltip={t('QAndATable.editquestion')}
                            to={`/qanda/${question.id}/edit`}
                        >
                            <em className="fas fa-pencil-alt" />
                        </TooltipLink>
                        <TooltipButton
                            id="deleteButton"
                            className="btn-danger pull-right"
                            tooltip={t('QAndATable.deletequestion')}
                            onClick={() => this.handleDeleteClicked(question)}
                        >
                            <em className="fa fa-trash" />
                        </TooltipButton>
                    </td>
                </tr>
            );
        });

        return (
            <div id="questions">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>{t('QAndATable.type')}</th>
                            <th>{t('QAndATable.description')}</th>
                            <th>{t('QAndATable.answer')}</th>
                            <th>
                                <em className="fa fa-cog" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>{questionRows}</tbody>
                </Table>
            </div>
        );
    }
}

export default translate('translations')(QAndATable);
